if (!customElements.get('cart-discounts')) {
  class CartDiscounts extends HTMLElement {
    constructor() {
      super();
      this._delegatedBound = false;
    }

    connectedCallback() {
      // Bind once per instance
      if (this._delegatedBound) return;
      this._delegatedBound = true;
      this._bindDelegatedEvents();
    }

    _bindDelegatedEvents() {
      // APPLY click (delegated)
      this.addEventListener('click', (event) => {
        const btn = event.target.closest('.cart-discounts--button');
        if (!btn) return;
        event.preventDefault();
        btn.classList.add('loading');
        this.updateDiscount();
      });

      // Enter on input (delegated)
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        const input = event.target.closest('.cart-discounts--input');
        if (!input) return;
        event.preventDefault();
        const btn = this.querySelector('.cart-discounts--button');
        if (btn) btn.classList.add('loading');
        this.updateDiscount();
      });

      // Remove discount (delegated; robust to SVG/icon clicks)
      this.addEventListener('click', (event) => {
        const removeBtn = event.target.closest('.cart-discounts--remove');
        if (!removeBtn) return;
        event.preventDefault();
        this.removeDiscount(removeBtn);
      });
    }

    getSectionsToRender() {
      return [
        { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
        { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
      ];
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    existingDiscounts() {
      return Array.from(this.querySelectorAll('.cart-discounts--name'))
        .map(pill => (pill.textContent || '').trim())
        .filter(Boolean);
    }

    updateDiscount() {
      const inputEl = this.querySelector('.cart-discounts--input');
      if (!inputEl) return;

      const discountCodeValue = (inputEl.value || '').trim();
      if (!discountCodeValue) return;

      const existingDiscounts = this.existingDiscounts();

      // Avoid duplicates (case-insensitive)
      if (existingDiscounts.some(c => c.toLowerCase() === discountCodeValue.toLowerCase())) {
        const btn = this.querySelector('.cart-discounts--button');
        if (btn) btn.classList.remove('loading');
        return;
      }

      existingDiscounts.push(discountCodeValue);
      this.renderDiscounts(existingDiscounts, discountCodeValue);
    }

    removeDiscount(removeBtn) {
      // Find the pill in the same row
      const row = removeBtn.closest('.cart-discounts--row');
      const pill = row?.querySelector('.cart-discounts--name');
      const discountCode = (pill?.textContent || '').trim();
      if (!discountCode) return;

      const existing = this.existingDiscounts();
      const idx = existing.findIndex(c => c.toLowerCase() === discountCode.toLowerCase());
      if (idx === -1) return;

      existing.splice(idx, 1);
      this.renderDiscounts(existing);
    }

    renderDiscounts(existingDiscounts, discountCodeValue) {
      const btn = this.querySelector('.cart-discounts--button');
      const err = this.querySelector('.cart-discounts--error');
      if (err) err.setAttribute('hidden', '');

      const body = JSON.stringify({
        discount: existingDiscounts.join(','),
        sections: this.getSectionsToRender().map((s) => s.section),
        sections_url: window.location.pathname
      });

      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body
      })
      .then((r) => r.text())
      .then((stateText) => {
        const parsedState = JSON.parse(stateText);

        // IMPORTANT: clear loading BEFORE replacing DOM
        if (btn) btn.classList.remove('loading');

        this.getSectionsToRender().forEach((section) => {
          const host = document.getElementById(section.id);
          const elementToReplace = host?.querySelector(section.selector) || host;
          if (parsedState.sections && elementToReplace) {
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        });

        // After replacement, the current element may be detached.
        const codeToCheck = (discountCodeValue || '').toLowerCase();
        const bad = parsedState.discount_codes?.find(d =>
          d.code?.toLowerCase() === codeToCheck && d.applicable === false
        );
        if (bad) {
          const freshComp = document.querySelector('cart-discounts');
          const newErr = freshComp?.querySelector('.cart-discounts--error');
          if (newErr) setTimeout(() => newErr.removeAttribute('hidden'), 300);
        }
      })
      .catch(() => {
        if (btn) btn.classList.remove('loading');
        if (err) err.removeAttribute('hidden');
      });
    }
  }

  customElements.define('cart-discounts', CartDiscounts);
}
